import { render } from "./VisitorHealthForm.vue?vue&type=template&id=1c07c850"
import script from "./VisitorHealthForm.vue?vue&type=script&lang=js"
export * from "./VisitorHealthForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__